import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

// Design tokens matched to the original Tailwind theme.
// Swap these for your actual theme values (or wire them to
// CSS custom properties like var(--ink)) if they differ.
const tokens = {
  ink: "#1a1a1a",
  inkBorder15: "rgba(26, 26, 26, 0.15)",
  inkBorder10: "rgba(26, 26, 26, 0.1)",
  concrete: "#f2f1ee",
  mutedForeground: "#6b6b6b",
  white: "#ffffff",
};

// Real HTML spec table for SEO crawlability
export function SpecTable({ specs, caption }) {
  if (!specs || specs.length === 0) return null;

  return (
    <TableContainer
      data-testid="spec-table"
      sx={{
        overflowX: "auto",
        border: `1px solid ${tokens.inkBorder15}`,
        backgroundColor: tokens.white,
        width: "100%",
      }}
    >
      <Table
        sx={{
          width: "100%",
          borderCollapse: "collapse",
          textAlign: "left",
          minWidth: { xs: 480, sm: 0 },
        }}
      >
        {caption && (
          <caption
            style={{
              position: "absolute",
              width: 1,
              height: 1,
              padding: 0,
              margin: -1,
              overflow: "hidden",
              clip: "rect(0, 0, 0, 0)",
              whiteSpace: "nowrap",
              border: 0,
            }}
          >
            {caption}
          </caption>
        )}

        <TableHead>
          <TableRow
            sx={{
              borderBottom: `1px solid ${tokens.ink}`,
              backgroundColor: tokens.ink,
            }}
          >
            <TableCell
              component="th"
              scope="col"
              sx={{
                width: "50%",
                fontFamily: "monospace",
                fontSize: { xs: "0.7rem", sm: "0.75rem" },
                textTransform: "uppercase",
                letterSpacing: "0.2em",
                px: { xs: 2.5, sm: 2.5 },
                py: 2,
                color: tokens.white,
                border: "none",
              }}
            >
              Parameter
            </TableCell>
            <TableCell
              component="th"
              scope="col"
              sx={{
                fontFamily: "monospace",
                fontSize: { xs: "0.7rem", sm: "0.75rem" },
                textTransform: "uppercase",
                letterSpacing: "0.2em",
                px: { xs: 2.5, sm: 2.5 },
                py: 2,
                color: tokens.white,
                border: "none",
              }}
            >
              Specification
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {specs.map(([param, value], i) => (
            <TableRow
              key={i}
              sx={{
                borderBottom: `1px solid ${tokens.inkBorder10}`,
                transition: "background-color 0.2s ease",
                "&:last-of-type": { borderBottom: "none" },
                "&:hover": { backgroundColor: tokens.concrete },
              }}
            >
              <TableCell
                component="th"
                scope="row"
                sx={{
                  px: { xs: 2.5, sm: 2.5 },
                  py: 2,
                  fontWeight: 500,
                  color: tokens.ink,
                  fontSize: "0.875rem",
                  verticalAlign: "top",
                  border: "none",
                }}
              >
                {param}
              </TableCell>
              <TableCell
                sx={{
                  px: { xs: 2.5, sm: 2.5 },
                  py: 2,
                  fontFamily: "monospace",
                  fontSize: "0.875rem",
                  color: tokens.mutedForeground,
                  fontVariantNumeric: "tabular-nums",
                  verticalAlign: "top",
                  border: "none",
                }}
              >
                {value}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default SpecTable;
